<template>
  <v-container fluid>
      <template v-if="loading">
        <LoadingScreen :isLoading="loading" />
      </template>
      <template v-else-if="isExistTopic">
        <v-row class="" justify="center" align-content="center">
          <v-col
            v-for="(item, i) in user.topics"
            :key="i"
          >
          <v-row justify="center" class="mt-2">
          <v-badge
            overlap
            left
            offset-x=54
            offset-y=34
            :value="isUnRead(item.unread)"
            color="black"
            class="font-weight-black"
            content="NEW"
          >
            <v-card
              class="mx-auto mt-0 d-flex flex-column"
              width="306"
              height="369"
              outlined
            >
              <v-badge
                avatar
                offset-x="30" offset-y="30"
                overlap
                :value="isDeadLink(item.is_have_dead_link)"
              >
                <template v-slot:badge>
                  <v-avatar>
                    <v-img src="../../assets/dead_link_badge.svg"></v-img>
                  </v-avatar>
                </template>
                <router-link :to="{ name: 'topic', params: { topic_code: item.topic_code }}" style="text-decoration: none;">
                  <v-img
                    class="white--text align-end"
                    style="height:170px"
                    :src="`${bucketUrl}${item.topic_image_url}`"
                  ></v-img>
                  <v-img v-if="isMyPage" :src="publicStateUrl(item.is_released)" height="30px" width="68px" position="left" style="position: absolute;left: 12px;top: 12px;"></v-img>
                </router-link>
              </v-badge>
              <v-card-text class="pt-4 overflow-auto">
                <router-link 
                  :to="{ name: 'topic', params: { topic_code: item.topic_code }}" 
                  class="font-weight-bold pt-0 mb-2"
                  style="
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-decoration: none;
                    color: black;
                  "
                >{{ item.topic_name }}</router-link>
                <span v-for="tag in item.tags" :key="tag.tag_name" class="mr-2">
                  <v-btn
                    depressed
                    dark
                    color="#333333"
                    @click="searchTag(tag.tag_name)"
                    x-small
                    class="font-weight-bold tag-name"
                    style="text-transform: none"
                  >{{ tag.tag_name }}</v-btn>
                </span>
              </v-card-text>
              <v-spacer></v-spacer>
              <v-divider class=""></v-divider>
              <v-card-text class="pa-1">
                <v-row class="">
                  <v-col cols="6" class="topic-updated-at" style="color: black; font-size: 10px;">
                    <time :datetime="formatDate(item.updated_at)">更新日：{{ formatDate(item.updated_at) }}</time>
                  </v-col>
                  <v-col cols="3" class="topic-preview-count" style="color: black; font-size: 14px;">
                    <v-icon size="16">mdi-eye</v-icon><span class="ml-1">{{ item.preview_count }}</span>
                  </v-col>
                  <v-col cols="3" class="topic-preview-count" style="color: black; font-size: 14px;">
                    <v-icon size="16">mdi-heart</v-icon><span class="ml-1">{{ item.lgtm }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            </v-badge>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <p class="ml-10 mt-5">作成したトピックはありません</p>
      </template>
  </v-container>
</template>
<script>
import dayjs from 'dayjs'
import LoadingScreen from "../atoms/LoadingScreen.vue";

export default {
  name: 'UserInfo',
  components: {
    LoadingScreen,
  },
  data() {
    return {
      drawer: true,
      loading: true,
      user: {
        icon_url: '',
        name: '',
        introduction_text: '',
        user_code: '',
      },
      favorited: false,
      topics: {},
      selectedItem: 0,
      is_auth: false,
      total_count: null,
      bucketUrl: process.env.VUE_APP_IMAGE_BUCKET_URL,
      isDisabled: true,
      isSelectTab: true
    }
  },
  computed: {
    isFavorited: function() {
      return this.favorited
    },
    isMyPage: function() {
      return this.getUserCode === this.$route.params.user_code;
    },
    isAuth() {
      return this.is_auth
    },
    isExistTopic() {
      return this.total_count > 0;
    },
    icon: function() {
      return this.user.icon_url
    },
    getUserCode: function() {
      return this.$store.getters['auth/isUserCode']
    },
  },
  methods: {
    // お気に入り
    favorite: function() {
      this.isDisabled = true;
      if(this.favorited){
        this.$store.dispatch('favorite/userDelete', this.user.user_code)
          .then(() => {
            this.favorited = false;
            this.isDisabled = false;
          })
      } else {
        this.$store.dispatch('favorite/userRegister', this.user.user_code)
          .then(() => {
            this.favorited = true;
            this.isDisabled = false;
          })
      }
    },
    searchTag($tag) {
      this.$router.push({ path: '/search_result', query: { tag: $tag } })
    },
    isUnRead: function(unRead) {
      return !this.isMyPage && unRead ? true : false;
    },
    formatDate: dateStr => dayjs(dateStr).format('YYYY/MM/DD'),
    setPublicRelationsTab() {
      this.isSelectTab = true
    },
    setUserTopicsTab() {
      this.isSelectTab = false
    },
    isDeadLink(isHaveDeadLink) {
      return this.isMyPage && isHaveDeadLink > 0 ? true : false;
    },
    publicStateUrl(isReleased) {
      return isReleased ? require('../../assets/is_private.svg') : require('../../assets/is_public.svg');
    },
    getMyPageData() {
      this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/profile')
        .then(response => {
          this.user = response.data
          this.loading = false;
          this.total_count = this.user.topics.length;
          this.is_auth = true
          this.$store.dispatch('favorite/users')
            .then(response => {
              response.map(user => {
                if(this.user.user_code === user.user_code) {
                  this.favorited = true;
                }
              })
              this.isDisabled = false;
            })
        });
    },
    getFavoriteUserData() {
      this.$axios.get(process.env.VUE_APP_API_BASE_URL + '/user/' + this.$route.params.user_code)
        .then(response => {
          this.user = response.data
          this.loading = false;
          this.total_count = this.user.topics.length;
          if(this.getUserCode) {
            this.is_auth = true
            this.$store.dispatch('favorite/users')
              .then(response => {
                response.map(user => {
                  if(this.user.user_code === user.user_code) {
                    this.favorited = true;
                  }
                })
                this.isDisabled = false;
              })
          }
        });
    }
  },
  watch: {
    async $route(to, from) {
      // ルートの変更の検知...
      if (to.params !== from.params) {
        // 初期化
        this.loading = true;
        if (this.isMyPage) {
          this.getMyPageData();
        } else {
          this.getFavoriteUserData();
        }
      }
    }
  },
  mounted: function () {
    if(this.isMyPage) {
      this.getMyPageData();
    } else {
      this.getFavoriteUserData();
    }
  },
};
</script>
<style scoped>
.tag-name:hover {
  color: #C388FF;
}
.topic-updated-at {
  padding: 12px 12px 12px 16px ;
}
.topic-preview-count {
  padding: 12px 0px 12px 0px ;
}
</style>